/*
 * @Author: klein
 * @Date: 2021-09-28 14:51:55
 * @Description:
 * @LastEditors: Klein
 * @LastEditTime: 2021-12-21 10:47:17
 * @FilePath: \planApp\src\mutation.js
 */
import { gql } from 'apollo-boost'

// PAID status ok  //后台支付
export const subscriptionNow = gql`
  mutation(
    $customerId:ID!
    $product: String!
    $planId: String
    $description: String!
    $chargeItems: String
    $objectId: String
  ) {
    checkoutSubscription(customerId: $customerId, product: $product, planId: $planId, 
      objectId: $objectId
      description: $description
      chargeItems: $chargeItems){
        id
        status
        statusDescription
        amountPaid
        total
        paymentIntentId
        redirect{
          iframeSrc
          iframeWidth
          iframeHeight
        }
    }
    
  }
`

export const CheckoutSubForOdoo = gql`
mutation($customerId: ID!, $product: String!, $planId: String!, $description: String!, $skuInfo: String!){
  checkoutSubForOdoo(
    customerId:$customerId,
    product:$product,
    planId:$planId,
    description:$description,
    skuInfo:$skuInfo
  ){
    status
    description
    subAddonInfos{
      id
      status
    }
    redirect{
      iframeSrc
    }
  }
}
`

export const checkOutNewSub = gql`
mutation ($customerId: ID!, $product: String!, $planId: String!, $description: String!, $chargeItems: String!){
  checkoutNewSubscription(
    customerId:$customerId,
    product:$product,
    planId:$planId,
    description:$description,
    chargeItems:$chargeItems
  ){
    id
    url
    state
  }
}`

// 支付成功后 去 后台校验 hostpage
export const customerPortalStatus = gql`
mutation ($customerId:ID!, $hostedPageId:String!) {
  customerPortalStatus(
    customerId: $customerId, 
    hostedPageId: $hostedPageId
  ){
    id
    status
  }
}
`

// 更改下个月订阅的addon信息
export const CheckoutAddon = gql`
  mutation (
    $customerId:ID!
    $product: String!
    $planId: String!
    $chargeItems: String!
  ){
    checkoutAddon(customerId: $customerId, product: $product, planId: $planId, chargeItems:$chargeItems)
  }
`

// 取消订阅
export const cancelSubscription = gql`
mutation (
  $product: String!
  $planId: String!
  $description: String!
  ) {
  cancelSubscription(product: $product, planId: $planId, description:$description,)
}
`

// 当去降级sub时,需要去check,运行的channel数量是否小于降级的数量
export const checkChannel = gql`
mutation (
  $customerId: ID!
  $chargeItems: String!
  ) {
  checkChannel(customerId: $customerId, chargeItems: $chargeItems)
}
`

// 获取绑定卡
export const createSetupIntent = gql`
mutation ($customerId:ID!, $product:String!) {
  createSetupIntent(
    customerId: $customerId, 
    product: $product
  ){
    clientSecret
  }
}
`
// 绑定卡 后通知后台
export const setDefaultPaymentMethod = gql`
  mutation ($customerId:ID!, $product:String!) {
    setDefaultPaymentMethod(customerId: $customerId, product: $product)
  }
`
//
export const addOrUpdateGroupInfo = gql`
  mutation (
    $apiKey: String!,
    $teamId: String,
    $userId: String,
    $chargeTime: String,
    $postPay: Int,
    $serviceType: String!,
    $planId: String,
    $deleteFlag: Int,
    $whiteListEndTime: String,
    $note: String
  ) {
    addOrUpdateGroupInfo(
      apiKey: $apiKey,
      teamId: $teamId,
      userId: $userId,
      chargeTime: $chargeTime,
      postPay: $postPay,
      serviceType: $serviceType,
      planId: $planId,
      deleteFlag: $deleteFlag,
      whiteListEndTime: $whiteListEndTime,
      note: $note
    )
  }
`

export const updateSkuTokenInfo = gql`
  mutation (
    $apiKey: String!,
    $planId: String!,
    $addonId: String!,
    $tokens: Float!
  ) {
    updatePlanAddon(
      apiKey: $apiKey,
      planId: $planId,
      addonId: $addonId,
      tokens: $tokens
    )
  }
`

export const addSkuTokenInfo = gql`
  mutation (
    $apiKey: String!,
    $planId: String!,
    $addonId: String!,
    $quantity: Int!,
    $tokens: Float!
  ) {
    addonBindPlan(
      apiKey: $apiKey,
      planId: $planId,
      addonId: $addonId,
      quantity: $quantity,
      tokens: $tokens
    )
  }
`

export const delSkuTokenInfo = gql`
  mutation (
    $apiKey: String!,
    $planId: String!,
    $addonId: String!,
    $deleteFlag: Int!,
  ) {
    updatePlanAddon(
      apiKey: $apiKey,
      planId: $planId,
      addonId: $addonId,
      deleteFlag: $deleteFlag
    )
  }
`

export const addNewSkuTokenInfo = gql`
  mutation (
    $apiKey: String!,
    $planId: String!,
    $addonId: String!,
    $serviceType: String!,
    $minQuantity: Int!,
    $maxQuantity: Int!
  ) {
    addSku(
      apiKey: $apiKey,
      planId: $planId,
      addonId: $addonId,
      serviceType: $serviceType,
      minQuantity: $minQuantity,
      maxQuantity: $maxQuantity
    )
  }
`

export const editFormulaInfo = gql`
  mutation (
    $apiKey: String!,
    $planId: String!,
    $metadata: String!
  ) {
    updatePlan(
      apiKey: $apiKey,
      planId: $planId,
      metadata: $metadata
    )
  }
`

export const deletePlanGQL = gql`
  mutation (
    $apiKey: String!,
    $planId: String!,
  ) {
    deletePlan(
      apiKey: $apiKey,
      planId: $planId
    )
  }
`

export const addNewPlan = gql`
  mutation (
    $apiKey: String!,
    $planId: String!,
    $serviceType: String!,
    $classification: Int!,
    $chargeCycle: Int!,
    $description: String!,
    $metadata: String!,
    $type: Int!,
    $level: Int!
  ) {
    addPlan(
      apiKey: $apiKey,
      planId: $planId,
      serviceType: $serviceType,
      classification: $classification,
      chargeCycle: $chargeCycle,
      description: $description,
      metadata: $metadata,
      type: $type,
      level: $level
    )
  }
`

/**
 * cache-first (default): return result from cache. Only fetch from network if cached result is not available.
cache-and-network: return result from cache first (if it exists), then return network result once it's available.
cache-only: return result from cache if available, fail otherwise.
network-only: return result from network, fail if network call doesn't succeed, save to cache.
no-cache: return result from network, fail if network call doesn't succeed, don't save to cache
 */
